import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    flexDirection: "column",
    gap: "calc(1 * var(--rhythm))",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      p: 0,
    },
  },

  title: {
    mb: "var(--rhythm)",
    [theme.breakpoints.down("md")]: {
      mt: "var(--rhythm)",
      mb: 0,
      ml: "var(--rhythm)",
    },
  },

  optimization: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "calc(2 * var(--rhythm))",
    p: "calc(2 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      gap: "var(--rhythm)",
      padding: "var(--rhythm)",
      borderRadius: 0,
    },
  },

  section: {
    width: "calc(50% - var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },

  group: {
    display: "flex",
    flexDirection: "column",
    gap: "calc(0.5 * var(--rhythm))",
  },

  control: {
    boxSizing: "border-box",
    width: "100%",
    height: "calc(3 * var(--rhythm))",
    marginX: 0,
    paddingX: "calc(0.5 * var(--rhythm))",
    border: "1px solid var(--color-grey-light)",
    borderRadius: "var(--border-radius)",
    boxShadow: "0 0 var(--width-10) 0 var(--color-grey-light)",
  },

  subtitle: {
    mt: "calc(1 * var(--rhythm))",
    [theme.breakpoints.down("md")]: {
      mt: 0,
      ml: "var(--rhythm)",
    },
  },

  maintenance: {
    p: "calc(2 * var(--rhythm))",
    ".RlxNumberField": {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      p: "calc(1 * var(--rhythm))",
      borderRadius: 0,
      ".RlxNumberField": {
        width: "100%",
      },
    },
  },
});
